module.exports = __webpack_public_path__ + "img/nathalie_vandermee.1c09a04d.jpg";